import { render, staticRenderFns } from "./EditSettings.vue?vue&type=template&id=2e18746a&scoped=true&"
import script from "./EditSettings.vue?vue&type=script&lang=js&"
export * from "./EditSettings.vue?vue&type=script&lang=js&"
import style0 from "./EditSettings.vue?vue&type=style&index=0&id=2e18746a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e18746a",
  null
  
)

export default component.exports